import * as z from 'zod';

export const GetEventsViewRequest = z.object({});
export const GetEventsViewResponse = z.object({
  eventsView: z
    .object({
      endDate: z
        .date()
        .describe(
          'End date of the event view in `YYYY-MM-DDThh:mm:ss.sssZ` format.'
        )
        .optional()
        .nullable(),
      futureDurationInDays: z
        .number()
        .int()
        .describe('Number of days from now until the event view ends.')
        .optional()
        .nullable(),
    })
    .describe('Retrieved event view.')
    .optional(),
});
